/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteImport } from './routes/account'
import { Route as CommunityRouteImport } from './routes/community'
import { Route as FlowRouteImport } from './routes/flow'
import { Route as FundingRouteImport } from './routes/funding'
import { Route as LabRequestRouteImport } from './routes/lab-request'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MylabRouteImport } from './routes/mylab'
import { Route as AccountIndexRouteImport } from './routes/account/index'
import { Route as AccountConsentRouteImport } from './routes/account/consent'
import { Route as AccountProfileRouteImport } from './routes/account/profile'
import { Route as AccountResearchInterestsRouteImport } from './routes/account/research-interests'
import { Route as GuestTokenRouteImport } from './routes/guest.$token'
import { Route as MylabIndexRouteImport } from './routes/mylab/index'
import { Route as MylabLabLogRouteImport } from './routes/mylab/lab-log'
import { Route as MylabLabsRouteImport } from './routes/mylab/labs'
import { Route as MylabMeetingRouteImport } from './routes/mylab/meeting'
import { Route as MylabPaperRouteImport } from './routes/mylab/paper'
import { Route as MylabScheduleRouteImport } from './routes/mylab/schedule'
import { Route as MylabUpcomingRouteImport } from './routes/mylab/upcoming'
import { Route as OnboardingAnalyzingRouteImport } from './routes/onboarding/analyzing'
import { Route as OnboardingProfileRouteImport } from './routes/onboarding/profile'
import { Route as OnboardingReviewRouteImport } from './routes/onboarding/review'
import { Route as OnboardingUploadRouteImport } from './routes/onboarding/upload'
import { Route as SettingsResearchInterestsRouteImport } from './routes/settings/research-interests'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunityRoute = CommunityRouteImport.update({
  id: '/community',
  path: '/community',
  getParentRoute: () => rootRouteImport,
} as any)
const FlowRoute = FlowRouteImport.update({
  id: '/flow',
  path: '/flow',
  getParentRoute: () => rootRouteImport,
} as any)
const FundingRoute = FundingRouteImport.update({
  id: '/funding',
  path: '/funding',
  getParentRoute: () => rootRouteImport,
} as any)
const LabRequestRoute = LabRequestRouteImport.update({
  id: '/lab-request',
  path: '/lab-request',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MylabRoute = MylabRouteImport.update({
  id: '/mylab',
  path: '/mylab',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountIndexRoute = AccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountRoute,
} as any)
const AccountConsentRoute = AccountConsentRouteImport.update({
  id: '/consent',
  path: '/consent',
  getParentRoute: () => AccountRoute,
} as any)
const AccountProfileRoute = AccountProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AccountRoute,
} as any)
const AccountResearchInterestsRoute =
  AccountResearchInterestsRouteImport.update({
    id: '/research-interests',
    path: '/research-interests',
    getParentRoute: () => AccountRoute,
  } as any)
const GuestTokenRoute = GuestTokenRouteImport.update({
  id: '/guest/$token',
  path: '/guest/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const MylabIndexRoute = MylabIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MylabRoute,
} as any)
const MylabLabLogRoute = MylabLabLogRouteImport.update({
  id: '/lab-log',
  path: '/lab-log',
  getParentRoute: () => MylabRoute,
} as any)
const MylabLabsRoute = MylabLabsRouteImport.update({
  id: '/labs',
  path: '/labs',
  getParentRoute: () => MylabRoute,
} as any)
const MylabMeetingRoute = MylabMeetingRouteImport.update({
  id: '/meeting',
  path: '/meeting',
  getParentRoute: () => MylabRoute,
} as any)
const MylabPaperRoute = MylabPaperRouteImport.update({
  id: '/paper',
  path: '/paper',
  getParentRoute: () => MylabRoute,
} as any)
const MylabScheduleRoute = MylabScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => MylabRoute,
} as any)
const MylabUpcomingRoute = MylabUpcomingRouteImport.update({
  id: '/upcoming',
  path: '/upcoming',
  getParentRoute: () => MylabRoute,
} as any)
const OnboardingAnalyzingRoute = OnboardingAnalyzingRouteImport.update({
  id: '/onboarding/analyzing',
  path: '/onboarding/analyzing',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingProfileRoute = OnboardingProfileRouteImport.update({
  id: '/onboarding/profile',
  path: '/onboarding/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingReviewRoute = OnboardingReviewRouteImport.update({
  id: '/onboarding/review',
  path: '/onboarding/review',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingUploadRoute = OnboardingUploadRouteImport.update({
  id: '/onboarding/upload',
  path: '/onboarding/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsResearchInterestsRoute =
  SettingsResearchInterestsRouteImport.update({
    id: '/settings/research-interests',
    path: '/settings/research-interests',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRouteWithChildren
  '/community': typeof CommunityRoute
  '/flow': typeof FlowRoute
  '/funding': typeof FundingRoute
  '/lab-request': typeof LabRequestRoute
  '/login': typeof LoginRoute
  '/mylab': typeof MylabRouteWithChildren
  '/account/consent': typeof AccountConsentRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/research-interests': typeof AccountResearchInterestsRoute
  '/guest/$token': typeof GuestTokenRoute
  '/mylab/lab-log': typeof MylabLabLogRoute
  '/mylab/labs': typeof MylabLabsRoute
  '/mylab/meeting': typeof MylabMeetingRoute
  '/mylab/paper': typeof MylabPaperRoute
  '/mylab/schedule': typeof MylabScheduleRoute
  '/mylab/upcoming': typeof MylabUpcomingRoute
  '/onboarding/analyzing': typeof OnboardingAnalyzingRoute
  '/onboarding/profile': typeof OnboardingProfileRoute
  '/onboarding/review': typeof OnboardingReviewRoute
  '/onboarding/upload': typeof OnboardingUploadRoute
  '/settings/research-interests': typeof SettingsResearchInterestsRoute
  '/account/': typeof AccountIndexRoute
  '/mylab/': typeof MylabIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/community': typeof CommunityRoute
  '/flow': typeof FlowRoute
  '/funding': typeof FundingRoute
  '/lab-request': typeof LabRequestRoute
  '/login': typeof LoginRoute
  '/account/consent': typeof AccountConsentRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/research-interests': typeof AccountResearchInterestsRoute
  '/guest/$token': typeof GuestTokenRoute
  '/mylab/lab-log': typeof MylabLabLogRoute
  '/mylab/labs': typeof MylabLabsRoute
  '/mylab/meeting': typeof MylabMeetingRoute
  '/mylab/paper': typeof MylabPaperRoute
  '/mylab/schedule': typeof MylabScheduleRoute
  '/mylab/upcoming': typeof MylabUpcomingRoute
  '/onboarding/analyzing': typeof OnboardingAnalyzingRoute
  '/onboarding/profile': typeof OnboardingProfileRoute
  '/onboarding/review': typeof OnboardingReviewRoute
  '/onboarding/upload': typeof OnboardingUploadRoute
  '/settings/research-interests': typeof SettingsResearchInterestsRoute
  '/account': typeof AccountIndexRoute
  '/mylab': typeof MylabIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRouteWithChildren
  '/community': typeof CommunityRoute
  '/flow': typeof FlowRoute
  '/funding': typeof FundingRoute
  '/lab-request': typeof LabRequestRoute
  '/login': typeof LoginRoute
  '/mylab': typeof MylabRouteWithChildren
  '/account/consent': typeof AccountConsentRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/research-interests': typeof AccountResearchInterestsRoute
  '/guest/$token': typeof GuestTokenRoute
  '/mylab/lab-log': typeof MylabLabLogRoute
  '/mylab/labs': typeof MylabLabsRoute
  '/mylab/meeting': typeof MylabMeetingRoute
  '/mylab/paper': typeof MylabPaperRoute
  '/mylab/schedule': typeof MylabScheduleRoute
  '/mylab/upcoming': typeof MylabUpcomingRoute
  '/onboarding/analyzing': typeof OnboardingAnalyzingRoute
  '/onboarding/profile': typeof OnboardingProfileRoute
  '/onboarding/review': typeof OnboardingReviewRoute
  '/onboarding/upload': typeof OnboardingUploadRoute
  '/settings/research-interests': typeof SettingsResearchInterestsRoute
  '/account/': typeof AccountIndexRoute
  '/mylab/': typeof MylabIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/community'
    | '/flow'
    | '/funding'
    | '/lab-request'
    | '/login'
    | '/mylab'
    | '/account/consent'
    | '/account/profile'
    | '/account/research-interests'
    | '/guest/$token'
    | '/mylab/lab-log'
    | '/mylab/labs'
    | '/mylab/meeting'
    | '/mylab/paper'
    | '/mylab/schedule'
    | '/mylab/upcoming'
    | '/onboarding/analyzing'
    | '/onboarding/profile'
    | '/onboarding/review'
    | '/onboarding/upload'
    | '/settings/research-interests'
    | '/account/'
    | '/mylab/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/community'
    | '/flow'
    | '/funding'
    | '/lab-request'
    | '/login'
    | '/account/consent'
    | '/account/profile'
    | '/account/research-interests'
    | '/guest/$token'
    | '/mylab/lab-log'
    | '/mylab/labs'
    | '/mylab/meeting'
    | '/mylab/paper'
    | '/mylab/schedule'
    | '/mylab/upcoming'
    | '/onboarding/analyzing'
    | '/onboarding/profile'
    | '/onboarding/review'
    | '/onboarding/upload'
    | '/settings/research-interests'
    | '/account'
    | '/mylab'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/community'
    | '/flow'
    | '/funding'
    | '/lab-request'
    | '/login'
    | '/mylab'
    | '/account/consent'
    | '/account/profile'
    | '/account/research-interests'
    | '/guest/$token'
    | '/mylab/lab-log'
    | '/mylab/labs'
    | '/mylab/meeting'
    | '/mylab/paper'
    | '/mylab/schedule'
    | '/mylab/upcoming'
    | '/onboarding/analyzing'
    | '/onboarding/profile'
    | '/onboarding/review'
    | '/onboarding/upload'
    | '/settings/research-interests'
    | '/account/'
    | '/mylab/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRouteWithChildren
  CommunityRoute: typeof CommunityRoute
  FlowRoute: typeof FlowRoute
  FundingRoute: typeof FundingRoute
  LabRequestRoute: typeof LabRequestRoute
  LoginRoute: typeof LoginRoute
  MylabRoute: typeof MylabRouteWithChildren
  GuestTokenRoute: typeof GuestTokenRoute
  OnboardingAnalyzingRoute: typeof OnboardingAnalyzingRoute
  OnboardingProfileRoute: typeof OnboardingProfileRoute
  OnboardingReviewRoute: typeof OnboardingReviewRoute
  OnboardingUploadRoute: typeof OnboardingUploadRoute
  SettingsResearchInterestsRoute: typeof SettingsResearchInterestsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/community': {
      id: '/community'
      path: '/community'
      fullPath: '/community'
      preLoaderRoute: typeof CommunityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flow': {
      id: '/flow'
      path: '/flow'
      fullPath: '/flow'
      preLoaderRoute: typeof FlowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/funding': {
      id: '/funding'
      path: '/funding'
      fullPath: '/funding'
      preLoaderRoute: typeof FundingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lab-request': {
      id: '/lab-request'
      path: '/lab-request'
      fullPath: '/lab-request'
      preLoaderRoute: typeof LabRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mylab': {
      id: '/mylab'
      path: '/mylab'
      fullPath: '/mylab'
      preLoaderRoute: typeof MylabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/': {
      id: '/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AccountIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/consent': {
      id: '/account/consent'
      path: '/consent'
      fullPath: '/account/consent'
      preLoaderRoute: typeof AccountConsentRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/profile': {
      id: '/account/profile'
      path: '/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AccountProfileRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/research-interests': {
      id: '/account/research-interests'
      path: '/research-interests'
      fullPath: '/account/research-interests'
      preLoaderRoute: typeof AccountResearchInterestsRouteImport
      parentRoute: typeof AccountRoute
    }
    '/guest/$token': {
      id: '/guest/$token'
      path: '/guest/$token'
      fullPath: '/guest/$token'
      preLoaderRoute: typeof GuestTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mylab/': {
      id: '/mylab/'
      path: '/'
      fullPath: '/mylab/'
      preLoaderRoute: typeof MylabIndexRouteImport
      parentRoute: typeof MylabRoute
    }
    '/mylab/lab-log': {
      id: '/mylab/lab-log'
      path: '/lab-log'
      fullPath: '/mylab/lab-log'
      preLoaderRoute: typeof MylabLabLogRouteImport
      parentRoute: typeof MylabRoute
    }
    '/mylab/labs': {
      id: '/mylab/labs'
      path: '/labs'
      fullPath: '/mylab/labs'
      preLoaderRoute: typeof MylabLabsRouteImport
      parentRoute: typeof MylabRoute
    }
    '/mylab/meeting': {
      id: '/mylab/meeting'
      path: '/meeting'
      fullPath: '/mylab/meeting'
      preLoaderRoute: typeof MylabMeetingRouteImport
      parentRoute: typeof MylabRoute
    }
    '/mylab/paper': {
      id: '/mylab/paper'
      path: '/paper'
      fullPath: '/mylab/paper'
      preLoaderRoute: typeof MylabPaperRouteImport
      parentRoute: typeof MylabRoute
    }
    '/mylab/schedule': {
      id: '/mylab/schedule'
      path: '/schedule'
      fullPath: '/mylab/schedule'
      preLoaderRoute: typeof MylabScheduleRouteImport
      parentRoute: typeof MylabRoute
    }
    '/mylab/upcoming': {
      id: '/mylab/upcoming'
      path: '/upcoming'
      fullPath: '/mylab/upcoming'
      preLoaderRoute: typeof MylabUpcomingRouteImport
      parentRoute: typeof MylabRoute
    }
    '/onboarding/analyzing': {
      id: '/onboarding/analyzing'
      path: '/onboarding/analyzing'
      fullPath: '/onboarding/analyzing'
      preLoaderRoute: typeof OnboardingAnalyzingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/profile': {
      id: '/onboarding/profile'
      path: '/onboarding/profile'
      fullPath: '/onboarding/profile'
      preLoaderRoute: typeof OnboardingProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/review': {
      id: '/onboarding/review'
      path: '/onboarding/review'
      fullPath: '/onboarding/review'
      preLoaderRoute: typeof OnboardingReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/upload': {
      id: '/onboarding/upload'
      path: '/onboarding/upload'
      fullPath: '/onboarding/upload'
      preLoaderRoute: typeof OnboardingUploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/research-interests': {
      id: '/settings/research-interests'
      path: '/settings/research-interests'
      fullPath: '/settings/research-interests'
      preLoaderRoute: typeof SettingsResearchInterestsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AccountRouteChildren {
  AccountConsentRoute: typeof AccountConsentRoute
  AccountProfileRoute: typeof AccountProfileRoute
  AccountResearchInterestsRoute: typeof AccountResearchInterestsRoute
  AccountIndexRoute: typeof AccountIndexRoute
}

const AccountRouteChildren: AccountRouteChildren = {
  AccountConsentRoute: AccountConsentRoute,
  AccountProfileRoute: AccountProfileRoute,
  AccountResearchInterestsRoute: AccountResearchInterestsRoute,
  AccountIndexRoute: AccountIndexRoute,
}

const AccountRouteWithChildren =
  AccountRoute._addFileChildren(AccountRouteChildren)

interface MylabRouteChildren {
  MylabLabLogRoute: typeof MylabLabLogRoute
  MylabLabsRoute: typeof MylabLabsRoute
  MylabMeetingRoute: typeof MylabMeetingRoute
  MylabPaperRoute: typeof MylabPaperRoute
  MylabScheduleRoute: typeof MylabScheduleRoute
  MylabUpcomingRoute: typeof MylabUpcomingRoute
  MylabIndexRoute: typeof MylabIndexRoute
}

const MylabRouteChildren: MylabRouteChildren = {
  MylabLabLogRoute: MylabLabLogRoute,
  MylabLabsRoute: MylabLabsRoute,
  MylabMeetingRoute: MylabMeetingRoute,
  MylabPaperRoute: MylabPaperRoute,
  MylabScheduleRoute: MylabScheduleRoute,
  MylabUpcomingRoute: MylabUpcomingRoute,
  MylabIndexRoute: MylabIndexRoute,
}

const MylabRouteWithChildren = MylabRoute._addFileChildren(MylabRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRouteWithChildren,
  CommunityRoute: CommunityRoute,
  FlowRoute: FlowRoute,
  FundingRoute: FundingRoute,
  LabRequestRoute: LabRequestRoute,
  LoginRoute: LoginRoute,
  MylabRoute: MylabRouteWithChildren,
  GuestTokenRoute: GuestTokenRoute,
  OnboardingAnalyzingRoute: OnboardingAnalyzingRoute,
  OnboardingProfileRoute: OnboardingProfileRoute,
  OnboardingReviewRoute: OnboardingReviewRoute,
  OnboardingUploadRoute: OnboardingUploadRoute,
  SettingsResearchInterestsRoute: SettingsResearchInterestsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
